import { FC } from 'react';
import { Modal, ModalOverlay } from '@chakra-ui/react';
import { REGISTRATION_STEP } from '../../../../constants/registrationStep';
import { useAddDetailStore } from '../../hooks';
import { CrawlerAddDetailInputModalView } from './CrawlerAddDetailInputModalView';
import { CrawlerAddDetailConfirmModalView } from './CrawlerAddDetailConfirmModalView';
import { CrawlerAddDetailResultModalView } from './CrawlerAddDetailResultModalView';

type Props = ReturnType<typeof useAddDetailStore>;

export const CrawlerAddDetailModalView: FC<Props> = ({
  isOpenModal,
  onCloseModal,
  currentModalStep,
  form,
  onConfirm,
  onGoBack,
  onSubmit,
  values,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="4xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    {currentModalStep === REGISTRATION_STEP.INPUT && (
      <CrawlerAddDetailInputModalView {...form} handleConfirm={onConfirm} />
    )}
    {currentModalStep === REGISTRATION_STEP.CONFIRMATION && (
      <CrawlerAddDetailConfirmModalView
        values={values}
        handleBack={onGoBack}
        handleSubmit={onSubmit}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.RESULT && (
      <CrawlerAddDetailResultModalView
        values={values}
        handleClose={onCloseModal}
      />
    )}
  </Modal>
);
